import styles from './StatusBadge.module.css';

const VARIANTS = {
    Pending: styles.pending,
    Confirmed: styles.confirmed,
    Completed: styles.completed,
    Ready: styles.ready,
    Active: styles.active,
    Inactive: styles.inactive,
    Cancelled: styles.inactive,
    Recommended: styles.active,
    // A listing that ran out its shelf life. Grey rather than red: the seller
    // did nothing wrong and one renew brings it back, unlike a decline.
    Expired: styles.muted,
    muted: styles.muted,
};

const StatusBadge = ({ status, variant }) => {
    return (
        <span className={`${styles.badge} ${VARIANTS[variant] || VARIANTS[status] || ''}`}>{status}</span>
    );
};

export default StatusBadge;
